module.exports = __webpack_public_path__ + "static/media/toyota_prius.5f66e103.png";